import "../../styles/header.css";
import { Dropdown, Space, Input, Avatar } from "antd";
import {
  LogoutOutlined,
  SearchOutlined,
  SettingOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { useUser } from "../../context/UserContext";

function initialsFromName(name) {
  if (!name) return "?";
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  return parts
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join("");
}

function Authenticated({ onLogout }) {
  const { displayName, email } = useUser();
  const initials = initialsFromName(displayName);

  const userMenuItems = {
    items: [
      {
        key: "profile",
        label: (
          <div className="user-menu-profile">
            <Avatar className="user-menu-avatar">{initials}</Avatar>
            <div>
              <div className="user-menu-name">{displayName}</div>
              <div className="user-menu-role">{email}</div>
            </div>
          </div>
        ),
        disabled: true,
      },
      { type: "divider" },
      {
        key: "settings",
        label: "Settings",
        icon: <SettingOutlined />,
      },
      {
        key: "logout",
        label: "Sign out",
        icon: <LogoutOutlined />,
        danger: true,
        onClick: () => onLogout?.(),
      },
    ],
  };

  return (
    <div className="app-topbar">
      <div className="app-topbar-left" />

      <div className="app-topbar-center">
        <Input
          prefix={<SearchOutlined className="search-icon" />}
          placeholder="Search anything..."
          className="app-topbar-search"
          allowClear
        />
      </div>

      <div className="app-topbar-right">
        <Space size={16}>
          <Dropdown
            menu={userMenuItems}
            trigger={["click"]}
            placement="bottomRight"
            overlayClassName="user-dropdown-overlay"
          >
            <div className="user-pill">
              <Avatar className="user-pill-avatar" size={28}>
                {initials}
              </Avatar>
              <span className="user-pill-name">{displayName}</span>
              <DownOutlined className="user-pill-caret" />
            </div>
          </Dropdown>
        </Space>
      </div>
    </div>
  );
}

export default Authenticated;
